<template>
<div>
  <vue-json-to-csv
    :json-data="formatedData"
    :labels="labels"
    :csv-title="csvTitle"
    :separator="';'"
    @success="val => handleSuccess(val)"
    @error="val => handleError(val)">
    <v-btn color="success" text>
      <v-icon class="mr-2">fas fa-file-export</v-icon> Exportar
    </v-btn>
  </vue-json-to-csv> 
</div>
</template>
<script>
import notifications from '@/utils/notifications'
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment'
import numeral from 'numeral'
export default {
  name:"ExportSalesByFamily",
  props:['data','filter','options','disabled'],
  components: {VueJsonToCsv,},
  data() {
    return {
      loading: false,
      workOrders:[],
      dataReady:false,
      labels:{ 
        id:{title:'Código'},
        name: { title: 'Familia' },
        line:{title:'Línea'},
        total_mts2:{title:'Mts2'},
        total_qty:{title:'Cantidad'},
        total_sales:{title:'Venta'},
       },
       csvTitle:`export_sales_by_family_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}`
    }
  },
  methods:{
    handleSuccess(val){
      console.log(val)
      notifications.showSuccess('Datos Exportados')
      this.dataReady=false
    },
    handleError(val){
      console.log(val)
      notifications.showError('Error Exportando Datos')
      this.dataReady=false
    }
  },
  computed:{
    formatedData(){
      const formated = this.data.map(d=> {return {
        id: d.id,
        name:d.name,
        line: d.line,
        total_mts2: numeral(d.total_mts2).format('0[.]00'),
        total_qty: numeral(d.total_qty).format('0[.]00'),
        total_sales: numeral(d.total_sales).format('0')
      }})
      return formated
    }
  }

}
</script>